import React, { forwardRef } from "react";
import PropTypes from "prop-types";

import { DirectionButton } from "../DirectionButton";

const PagedMenuEntry = forwardRef(
  ({ tag, children, small, ...others }, ref) => (
    <DirectionButton
      ref={ref}
      tag="a"
      direction="none"
      small={small}
      {...others}
    >
      {children}
    </DirectionButton>
  )
);

PagedMenuEntry.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  small: PropTypes.bool,
  tag: PropTypes.string,
};

PagedMenuEntry.defaultProps = {
  small: false,
  tag: undefined,
};

PagedMenuEntry.displayName = "PagedMenuEntry";

export default PagedMenuEntry;
